export interface NewUser {
  firstName: string;
  lastName: string;
  badgeNumber: string;
  department: string;
  email: string;
  position: string; // legacy compatibility
  isAdmin?: boolean;
}

export const validateUser = (user: NewUser): string[] => {
  const errors: string[] = [];

  if (!user.firstName.trim()) errors.push("First Name is required");
  if (!user.lastName.trim()) errors.push("Last Name is required");
  if (!user.position.trim()) errors.push("Position is required");
  if (!user.badgeNumber.trim()) {
    errors.push("Badge Number is required");
  } else if (!/^[a-zA-Z0-9]{1,10}$/.test(user.badgeNumber.trim())) {
    errors.push("Badge Number must be 1 to 10 alphanumeric characters");
  }
  if (!user.department.trim()) errors.push("Department is required");
  if (!user.email.trim()) errors.push("Email is required");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (user.email && !emailRegex.test(user.email)) {
    errors.push("Invalid email format");
  }

  return errors;
};
